export const CREATE_NEWS = "CREATE_NEWS"
export const GET_NEWS = "GET_NEWS"
export const SET_NEWS = "SET_NEWS"
export const DELETE_NEWS = "DELETE_NEWS"
export const SET_NEWS_STATE = "SET_NEWS_STATE"
export const PATCH_NEWS = "PATCH_NEWS"
